import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../../common/components';

const EditUserContact = loadable(() => import('./EditUserContact'), {
    fallback: <Loader/>,
});
const ViewUserContact = loadable(() => import('./ViewUserContact'), {
    fallback: <Loader/>,
});
const UserContactRoutes = ({ t, alert }) => {
  return [
    <Route key="edit_user_contact" exact path="/edit/:id" element={<EditUserContact t={t} alert={alert} />} />,
    <Route
      key="view_user_contact"
      exact
      path="/view/:id/contact"
      element={<ViewUserContact t={t} alert={alert} />}
    />
  ];
};
UserContactRoutes.propTypes = {
  t: PropTypes.func
};
export default UserContactRoutes;
